// extracted by mini-css-extract-plugin
export default {"base":"styles__base---40Po","horizontal-padding":"styles__horizontal-padding--ya4Rc","small":"styles__small--dQwHm","medium":"styles__medium--Fasq1","large":"styles__large--7jfgo"};